import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type BadgeVariant =
  | 'default'
  | 'secondary'
  | 'destructive'
  | 'outline';

@Component({
  selector: 'app-badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './badge.component.html',
  styleUrl: './badge.component.scss'
})
export class BadgeComponent {
  @Input() variant: BadgeVariant = 'default';

  get classes(): string[] {
    return [
      BASE_CLASSES,
      VARIANT_CLASSES[this.variant]
    ];
  }
}

/* ---------------- constants ---------------- */

const BASE_CLASSES =
  'whitespace-nowrap inline-flex items-center rounded-md border ' +
  'px-2.5 py-0.5 text-xs font-semibold transition-colors ' +
  'focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 ' +
  'hover-elevate';

const VARIANT_CLASSES: Record<BadgeVariant, string> = {
  default:
    'border-transparent bg-primary text-primary-foreground shadow-xs',
  secondary:
    'border-transparent bg-secondary text-secondary-foreground',
  destructive:
    'border-transparent bg-destructive text-destructive-foreground shadow-xs',
  outline:
    'border [border-color:var(--badge-outline)] shadow-xs'
};
